// components/PlanGate.jsx
//
// Route guard for pages that require a plan above Starter (e.g. User
// Management). Sits alongside ProtectedRoute — ProtectedRoute checks auth,
// PlanGate checks plan tier.
//
// Usage (App.js):
//   <Route
//     path="/user-management"
//     element={
//       <PlanGate>
//         <UserManagementPage />
//       </PlanGate>
//     }
//   />

import React from "react";
import { Navigate } from "react-router-dom";
import { useStorageStore } from "../store/storageStore";
import { isStarterPlan } from "../utils/planAccess";

const PlanGate = ({ children, redirectTo = "/dashboard" }) => {
  const plan = useStorageStore((s) => s.plan);
  const loading = useStorageStore((s) => s.loading);

  // Storage/plan data loads asynchronously on app mount (SideBar kicks off
  // fetchStorageUsage). Don't redirect on the default "starter" placeholder
  // before we actually know the org's real plan — that would incorrectly
  // bounce Basic/Pro orgs on a fresh page load / direct URL hit.
  if (loading) {
    return (
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          minHeight: "60vh",
          color: "#6b7280",
          fontSize: 14,
        }}
      >
        Loading…
      </div>
    );
  }

  if (isStarterPlan(plan)) {
    return <Navigate to={redirectTo} replace />;
  }

  return children;
};

export default PlanGate;
